import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import TabButtonGroup from '@/shared/components/ui/TabButton'
import useMediaQuery from '@/shared/hooks/useMediaQuery'
import { getBrowserEnv } from '@/shared/utils'
import { mediaTablet } from '@/styles/mediaQuery'

const Support = () => {
  const { pathname } = useLocation()
  const { isMobile } = useMediaQuery()

  const navigate = useNavigate()

  const isWebView = getBrowserEnv() === 'webview'
  const isHiddenInWebView =
    isWebView &&
    (pathname.includes('notice') || pathname.includes('faq') || pathname.includes('terms'))

  const SUPPORT_ROUTE = [
    { label: '공지사항', path: '/notice' },
    { label: '새소식', path: '/news' },
    { label: isMobile ? '자주묻는\n질문' : '자주묻는질문', path: '/faq' },
    { label: '서비스\n환불', path: '/refund' },
    { label: '1:1 문의', path: '/center' },
  ]

  const matchedIndex = SUPPORT_ROUTE.findIndex((route) => pathname.includes(route.path))
  const activeIndex = matchedIndex === -1 ? 0 : matchedIndex

  return (
    <Wrap>
      {!isHiddenInWebView && (
        <TabButtonGroup
          tabs={SUPPORT_ROUTE.map((tab) => tab.label)}
          activeIndex={activeIndex}
          onChange={(index) => navigate(SUPPORT_ROUTE[index].path)}
          className="support-tab"
        />
      )}
      <Outlet />
    </Wrap>
  )
}

export default Support

const Wrap = styled.div`
  max-width: 1120px;
  margin: 0 auto;
  margin-top: 60px;

  ${mediaTablet} {
    margin-top: 40px;
  }
`
